<div fxLayout="column" ngClass.desktop="pl-56 pr-56 pt-48 pb-48 shadow-content" ngClass.mobile="p-16 w-100"
     fxFlexAlign="center" fxLayoutAlign="center center">
    <ui-kit-svg class="i-80" [name]="qrAppearance === QrAppearance.CAMERA_FAILED ? 'ic_error_camera' : 'ic_scan_qr'"></ui-kit-svg>
    <div class="h3-semi-bold text-center c-primary-gray-900 mt-40 pre-line">
        {{ (qrAppearance === QrAppearance.CAMERA_FAILED ? 'i18n_auth_errorLivenessCameraNotFoundTitle' : 'i18n_auth_qrManuallyScanTitle') | translate }}
    </div>
    <div class="t2 mt-16 pre-line text-center">
        {{ (qrAppearance === QrAppearance.CAMERA_FAILED ? 'i18n_auth_errorLivenessCameraNotFoundSubtitle' : 'i18n_auth_qrManuallyScanSubtitle') | translate }}
    </div>
    @if (qrCodeData && !Spinner.isShown('createQr', 'livenessQrScanned')) {
        <qrcode [qrdata]="qrCodeData"
            [width]="200"
            class="mt-12"
            [errorCorrectionLevel]="'L'"/>
    }
    <ui-kit-spinner [spinnerIds]="['createQr', 'livenessQrScanned']"
                    [diameter]="32"
                    [class.mt-40]="Spinner.isShown('livenessQrScanned')"/>
</div>
